import React from 'react';
import { Card, Empty } from 'antd';
import { ResponsivePie } from '@nivo/pie';

const colorMap = {
  Image: '#69b1ff',
  Text: '#52c41a',
  'Email Attachment': '#faad14',
};

export default function UserSubmissionContentCard({ data }) {
  const rows = data || [];
  const total = rows.reduce((s, r) => s + (r.count || r.value || 0), 0) || 1;
  const items = rows.map((r) => ({
    id: r.type || r.id,
    label: r.type || r.id,
    value: r.count ?? r.value ?? 0,
  }));

  return (
    <Card title={<span style={{ fontSize: 14, fontWeight: 600 }}>User Submission Content</span>}>
      <div style={{ height: 240 }}>
        {!rows || rows.length === 0 ? (
          <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        ) : (
          <ResponsivePie
            data={items}
            innerRadius={0}
            padAngle={1}
            colors={({ id }) => colorMap[id] || '#ccc'}
            enableArcLinkLabels
            arcLinkLabelsTextColor="#595959"
            arcLinkLabelsColor={{ from: 'color' }}
            arcLinkLabelsSkipAngle={10}
            arcLabelsSkipAngle={360}
            arcLinkLabelsDiagonalLength={8}
            arcLinkLabelsStraightLength={10}
            margin={{ top: 10, right: 110, bottom: 10, left: 90 }}
            startAngle={-180}
            endAngle={180}
            sortByValue={true}
            tooltip={({ datum }) => {
              const value = datum?.value ?? 0;
              const percent = ((value / total) * 100).toFixed(1);
              return (
                <div style={{ padding: '8px 10px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, boxShadow: '0 2px 6px rgba(0,0,0,0.08)', minWidth: 150 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <span style={{ width: 12, height: 12, background: datum?.color, borderRadius: 3, display: 'inline-block' }} />
                    <span style={{ fontWeight: 600 }}>{datum?.label || datum?.id}</span>
                  </div>
                  <div>
                    <span style={{ color: '#595959' }}>Count: </span>
                    <span style={{ fontWeight: 600 }}>{value}</span>
                  </div>
                  <div>
                    <span style={{ color: '#595959' }}>Percent: </span>
                    <span style={{ fontWeight: 600 }}>{percent}%</span>
                  </div>
                </div>
              );
            }}
            arcLinkLabel={(d) => {
              const percent = Math.round((d.value / total) * 100);
              return `${d.id}  ${percent}%`;
            }}
          />
        )}
      </div>
    </Card>
  );
}


